import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-spinner-component',
  templateUrl: './progress-spinner-component.component.html',
  styleUrls: ['./progress-spinner-component.component.scss']
})
export class ProgressSpinnerComponentComponent implements OnInit {

  constructor() { }
  
  ngOnInit(): void {
  }
}
